import { FaMicrophone, FaMicrophoneSlash } from 'react-icons/fa'
import { Button, Tooltip } from '@outbound-ai/ursa'
import styled, { css } from 'styled-components'
import { PositionEnum } from 'types/cssTypes'

interface IProps {
  isMuted: boolean
  toggleIsMuted: () => void
}

export const MuteUnmuteMicrophone = ({ isMuted, toggleIsMuted }: IProps) => {
  const handleClick = () => toggleIsMuted()

  return (
    <Span isMuted={isMuted}>
      {isMuted ? (
        <Tooltip
          tooltipText="Click to unmute your microphone "
          position={PositionEnum.top}
          positionContent={100}
          positionTooltipArrow={32}
          tooltipStyles={{ 'min-width': '10rem' }}
        >
          <Button
            variant="danger"
            contentType="icon-only"
            radius="rounded"
            onClick={handleClick}
            className="action-button"
          >
            <FaMicrophoneSlash />
          </Button>
        </Tooltip>
      ) : (
        <Tooltip
          tooltipText="Click to mute your microphone"
          position={PositionEnum.top}
          positionContent={100}
          positionTooltipArrow={32}
          tooltipStyles={{ 'min-width': '10rem' }}
        >
          <Button
            variant="info"
            contentType="icon-only"
            radius="rounded"
            onClick={handleClick}
            className="action-button"
          >
            <FaMicrophone />
          </Button>
        </Tooltip>
      )}
    </Span>
  )
}

const Span = styled.span<{ isMuted: boolean }>`
  .action-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${({ theme }) => theme.util.pixelToRem(45)};
    height: ${({ theme }) => theme.util.pixelToRem(45)};
    border: 1px solid ${({ theme }) => theme.colors.grey.lighter};
    border-radius: 0.75rem;
    padding: ${({ theme }) => `${theme.spacing.s} ${theme.spacing.xs}`};
    background-color: ${({ theme }) => theme.colors.error.dark};

    ${({ isMuted }) =>
      !isMuted &&
      css`
        background-color: ${({ theme }) => theme.colors.info.darker};
      `}

    svg {
      width: ${({ theme }) => theme.spacing.m};
      height: ${({ theme }) => theme.spacing.s};
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.grey.lighter};

      ${({ isMuted }) =>
        !isMuted &&
        css`
          background-color: ${({ theme }) => theme.colors.primary.darker};
        `}
      cursor: pointer;
    }

    &:focus {
      box-shadow: none;
    }
  }
`
